// src/Home.js
import React, { useState } from 'react';
import api from './Api';

const Home = () => {
  const [email, setEmail] = useState('');

  const handleAuth = async () => {
    if (!email) return alert("Email is required");
    localStorage.setItem('userEmail', email);

    try {
      const res = await api.post('/ebayUrlFB');
      const authUrl = res.data.url;
      window.location.href = authUrl;
    } catch (error) {
      console.error("Error generating eBay auth URL:", error);
      alert("Failed to get eBay Auth URL");
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h2 style={styles.heading}>Connect Your eBay Store</h2>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />
        <button onClick={handleAuth} style={styles.button}>
          Authenticate with eBay
        </button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    height: '100vh',
    background: '#f6f9fc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter, sans-serif',
  },
  card: {
    background: '#fff',
    padding: '2rem',
    borderRadius: '16px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.05)',
    width: '90%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  heading: {
    marginBottom: '1.5rem',
    fontSize: '1.5rem',
    color: '#333',
  },
  input: {
    width: '300px',
    padding: '12px 16px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    marginBottom: '1rem',
    outline: 'none',
  },
  button: {
    background: '#0064d2',
    color: '#fff',
    padding: '12px 20px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: '0.3s',
  },
};

export default Home;
